export default __webpack_public_path__ + "static/media/Tommaso Giartosio.9bf15042.jpg";